import $ from 'jquery';

let __registry__;

class ComponentRegistry {
    constructor () {
        this._registry = {};
        this._document = document;
        this._observer = this.createObserver();
    }

    static getInstance() {
        return __registry__ instanceof ComponentRegistry ? __registry__ : (__registry__ = new ComponentRegistry());
    }

    static connectComponent (ctor, node, props, context) {
        const component = new ctor(node, props, context);

        $(node).setComponent(component);
        (component.connectedCallback || function(){}).call(component);
    }

    static notifyAttributeChange (component, attrName, newValue, oldValue) {
        (component.attributeChangedCallback || function(){}).call(component, attrName, newValue, oldValue);
    }

    static connectComponents (addedNodes, registry) {
        const { connectComponent } = ComponentRegistry;

        for (let selector in registry) {
            const nodes = $(addedNodes).filter(selector);

            if (nodes.length < 1)
                continue;

            nodes.each(function () {
                let node = this;

                const { ctor, props, context, lazy } = registry[selector];

                if (ctor) {
                    if (lazy && ctor.hasOwnProperty('loader')) {
                        ctor.loader(connectComponent, node, props, context);
                        return;
                    }

                    connectComponent(ctor, node, props, context);
                }
            });
        }
    }

    static changeComponentAttrs (target, attrName, oldValue) {
        const element = $(target);
        const component = element.getComponent();
        const newValue = element.attr(attrName);
        const { notifyAttributeChange } = ComponentRegistry;

        if (!component) {
            return;
        }

        const observedAttributes = component.constructor.observedAttributes || [];

        if (observedAttributes.indexOf(attrName) > -1) {
            notifyAttributeChange(component, attrName, newValue, oldValue);
        }
    }

    _handleMutations (mutations) {
        const registry = this.getRegistry();

        for (let i = 0; i < mutations.length; i++) {
            const mutation = mutations[i];

            switch (mutation.type) {
                case 'childList':
                    ComponentRegistry.connectComponents(mutation.addedNodes, registry);
                    break;

                case 'attributes':
                    ComponentRegistry.changeComponentAttrs(
                        mutation.target,
                        mutation.attributeName,
                        mutation.oldValue,
                        registry
                    );
                    break;
            }
        }
    }

    getObserver () {
        return this._observer;
    }

    getRegistry () {
        return this._registry;
    }

    createObserver () {
        return new MutationObserver(this._handleMutations.bind(this));
    }

    registerComponent (selector, ctor, props, context, lazy) {
        const registry = this.getRegistry();

        if (registry.hasOwnProperty(selector))
            throw new Error(`${selector} already registered!`);

        registry[selector] = {
            ctor,
            props,
            lazy,
            context: context || this._document,
        };
    }

    getComponentDefinition (selector) {
        const registry = this.getRegistry();

        if (!registry.hasOwnProperty(selector))
            throw new Error(`${selector} is not registered!`);

        return registry[selector];
    }

    observeMutations (node, config) {
        const { observerDefaults } = ComponentRegistry;
        return this.getObserver().observe(node || this._document, { ...observerDefaults, ...config });
    }

    disconnectRegistry () {
        this.getObserver().disconnect();
    }
}

ComponentRegistry.observerDefaults = {
    attributes: true,
    childList: true,
    subtree: true
};

export default ComponentRegistry;